import { GlassFragileIcon } from './GlassFragileIcon';

/**
 * author: Colton Wiscombe
 * id 8D20FB31-71AC-4697-899B-2156B6193F75
 * name glass-fragile
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/glass-fragile.svg
 * tags
 * - Food / Drink 
 */
export const GlassBrokenIcon = GlassFragileIcon;
export default GlassBrokenIcon